import {hot} from 'react-hot-loader';
import React from 'react';
import {LocalDocumentationPage} from '@homeaway/react-documentation';
import documentationData from '../../../build/documentationData.json';

/**
 *
 * Documentation
 *
 *
 * To work on this locally, run:
 *     npm run start:docs
 */
const Doc = () => (
    <LocalDocumentationPage documentationData={documentationData} />
);

export default hot(module)(Doc);
